import { render, staticRenderFns } from "./RendererControls.vue?vue&type=template&id=5c6c6ce5"
import script from "./RendererControls.vue?vue&type=script&lang=js"
export * from "./RendererControls.vue?vue&type=script&lang=js"
import style0 from "./RendererControls.vue?vue&type=style&index=0&id=5c6c6ce5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports